/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Proof_Vivid_Wolf_InspireInputs */

const fr_proof_vivid_wolf_inspire = /** @type {(inputs: Proof_Vivid_Wolf_InspireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demande d'essai`)
};

/**

* @param {Proof_Vivid_Wolf_InspireInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const proof_vivid_wolf_inspire = /** @type {((inputs?: Proof_Vivid_Wolf_InspireInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Proof_Vivid_Wolf_InspireInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_proof_vivid_wolf_inspire(inputs)
});